import {
    plataforma
} from "./config";

export default { 
    plataforma: (headers) => {
        return plataforma.get("/v1/api-suporte/plataformas", headers)
    }
}